var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "material-symbols:notifications-unread-outline"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.0523 24.1534C15.6417 24.1534 15.2912 24.0074 15.0011 23.7154C14.7109 23.424 14.5658 23.0736 14.5658 22.6642H17.5443C17.5443 23.0761 17.3983 23.4271 17.1063 23.7172C16.8137 24.008 16.4624 24.1534 16.0523 24.1534ZM9.6001 21.7411V20.819H11.0894V13.5128C11.0894 12.3079 11.4705 11.2484 12.2328 10.3342C12.9963 9.42007 13.9631 8.85049 15.1329 8.62549V8.122C15.1329 7.86565 15.2224 7.64802 15.4013 7.46912C15.5802 7.28961 15.7975 7.19986 16.0532 7.19986C16.3084 7.19986 16.5263 7.28961 16.707 7.46912C16.8872 7.64802 16.9772 7.86565 16.9772 8.122V8.19116C16.8438 8.39895 16.727 8.60889 16.6268 8.82098C16.526 9.03246 16.4476 9.25746 16.3917 9.49599L16.2275 9.47755C16.174 9.47263 16.1166 9.47017 16.0551 9.47017C14.9344 9.47017 13.9803 9.86362 13.1928 10.6505C12.4059 11.438 12.0124 12.3921 12.0124 13.5128V20.819H20.0987V15.2133C20.245 15.2422 20.3956 15.2646 20.5505 15.2806C20.7067 15.2959 20.8634 15.2978 21.0208 15.2861V20.819H22.5101V21.7411H9.6001ZM20.6326 13.1052C19.9932 13.1052 19.4486 12.8812 18.9986 12.433C18.5498 11.9855 18.3254 11.4417 18.3254 10.8017C18.3254 10.1624 18.5492 9.61802 18.9967 9.16863C19.4449 8.71924 19.9889 8.49455 20.6289 8.49455C21.2683 8.49455 21.8123 8.71832 22.2611 9.16586C22.7099 9.61341 22.9349 10.1575 22.9361 10.7981C22.9361 11.4374 22.712 11.9818 22.2639 12.4312C21.8163 12.8799 21.2732 13.1052 20.6326 13.1052Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.4f1fc1917a3cfdc5644519272c2a02b4.svg";
export { ForwardRef as ReactComponent };